import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const storyJury = {
  fetchListJury: lazyModuleMethod(() => import('./fetchListJury'), 'default'),
  createJury: lazyModuleMethod(() => import('./createJury'), 'default'),
  fetchJury: lazyModuleMethod(() => import('./fetchJury'), 'default'),
  editJury: lazyModuleMethod(() => import('./editJury'), 'default'),
  deleteJury: lazyModuleMethod(() => import('./deleteJury'), 'default'),
}
